module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2f5Py"))).then(() => parcelRequire('hEqeo'));